import React from 'react';
import Modal from '../Modal';

var Drawer = function Drawer(props) {
  return (
    /*#__PURE__*/
    React.createElement(Modal, Object.assign({}, props, {
      drawer: true
    }))
  );
};

Drawer.defaultProps = {
  position: 'right',
  width: 'auto'
};
Drawer.displayName = 'ShineoutDrawer';
Drawer.Submit = Modal.Submit;
export default Drawer;